"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.roleOptions = exports.roles = void 0;
exports.roles = [
    'Field Crew',
    'Foreman',
    'Superintendent',
    'Project Engineer/Asst PM',
    'Project Manager',
    'Office Manager',
    'Accounting/Payroll',
    'VDC/BIM',
    'Field Operations Exec',
    'Project Management Exec',
    'CFO',
    'CEO',
    'Other',
];
exports.roleOptions = new Set(exports.roles.map(function (role) { return ({
    text: role,
    value: role,
}); }));
